const RELOAD_FLAG='asans.chunk-reload';
const sleep=ms=>new Promise(resolve=>setTimeout(resolve,ms));
// A code chunk can fail on a flaky connection or while a new release is switching over.
// Retry the download a few times, then reload the page once to pick up the current build.
export async function importWithRetry(load,{attempts=3,delay=700,storage=globalThis.sessionStorage,reload=()=>window.location.reload()}={}){
  let lastError;
  for(let attempt=0;attempt<attempts;attempt++){
    try{
      const module=await load();
      try{storage?.removeItem(RELOAD_FLAG);}catch{}
      return module;
    }catch(error){
      lastError=error;
      if(attempt<attempts-1) await sleep(delay*(attempt+1));
    }
  }
  const isChunkError=/Loading (CSS )?chunk|ChunkLoadError|dynamically imported module/i.test(`${lastError?.name} ${lastError?.message}`);
  let reloaded=false;
  try{reloaded=storage?.getItem(RELOAD_FLAG)==='1';}catch{}
  if(isChunkError&&!reloaded){
    try{storage?.setItem(RELOAD_FLAG,'1');}catch{}
    reload();
    return new Promise(()=>{});
  }
  throw lastError;
}
